import { configureStore } from '@reduxjs/toolkit'
import { authReducer } from './slices/auth'
import { cardsReducer } from './slices/cards'
import { categoriesListenerMiddleware, categoriesReducer } from './slices/categories'

const store = configureStore({
    reducer: {
        cards: cardsReducer,
        auth: authReducer,
        categories: categoriesReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().prepend(categoriesListenerMiddleware.middleware),
})

export default store